import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageScrollService {

  private isScrolling = false;
  constructor() { }


  scroll(options: {
    document: any,
    duration: number,
    scrollTarget: string,
    scrollOffset?: number,
    easingPattern?: string,
  }) {
    if (this.isScrolling) {
      return;
    }
    this.isScrolling = true;
    let injectDoc = (options.document as Document);
    let element = injectDoc.querySelector(options.scrollTarget);
    let scrollTo = element.getBoundingClientRect().y || element.getBoundingClientRect().top;
    let scrollTop = injectDoc.documentElement.scrollTop || injectDoc.body.scrollTop;
    new SmoothScroll(scrollTo + scrollTop - (options.scrollOffset||0),{
      duration:options.duration,
      scrollTop:scrollTop,
      easingPattern: options.easingPattern,
    }, (duringScrolling) => {
      this.isScrolling = duringScrolling;
    });
  }
}


class SmoothScroll {
  constructor(position: any, options: any, duringScrolling: any) {
    this.smoothScroll(position, options, duringScrolling);
  }
  private smoothScroll(endposition, options, duringScrolling) {
    options = options || {};

    // Options
    let duration = options.duration || 800,
      //offset = options.offset || 0,
      //easing = options.easing || 'easeInOutQuart',
      container = options.element||null,//document.getElementById(options.containerId) || null,
      containerPresent = (container != undefined && container != null);
      let getScrollLocation = ()=>{
        return options.scrollTop || 0;
      };
     // middleAlign = options.middleAlign || false;

    /**
     * Retrieve current location
     */
    // let getScrollLocation = () => {
    //   if (containerPresent) {
    //     return container.scrollTop;
    //   } else {
    //     if (window.pageYOffset) {
    //       return window.pageYOffset;
    //     } else {
    //       return document.documentElement.scrollTop;
    //     }
    //   }
    // };

    /**
     * Calculate easing pattern.
     *
     * 20150713 edit - zephinzer
     * - changed if-else to switch
     * @see http://archive.oreilly.com/pub/a/server-administration/excerpts/even-faster-websites/writing-efficient-javascript.html
     */
    let getEasingPattern = (type, time) => {
      switch (type) {
        case 'easeInQuad': return time * time; // accelerating from zero velocity
        case 'easeOutQuad': return time * (2 - time); // decelerating to zero velocity
        case 'easeInOutQuad': return time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time; // acceleration until halfway, then deceleration
        case 'easeInCubic': return time * time * time; // accelerating from zero velocity
        case 'easeOutCubic': return (--time) * time * time + 1; // decelerating to zero velocity
        case 'easeInOutCubic': return time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1; // acceleration until halfway, then deceleration
        case 'easeInQuart': return time * time * time * time; // accelerating from zero velocity
        case 'easeOutQuart': return 1 - (--time) * time * time * time; // decelerating to zero velocity
        case 'easeInOutQuart': return time < 0.5 ? 8 * time * time * time * time : 1 - 8 * (--time) * time * time * time; // acceleration until halfway, then deceleration
        case 'easeInQuint': return time * time * time * time * time; // accelerating from zero velocity
        case 'easeOutQuint': return 1 + (--time) * time * time * time * time; // decelerating to zero velocity
        case 'easeInOutQuint': return time < 0.5 ? 16 * time * time * time * time * time : 1 + 16 * (--time) * time * time * time * time; // acceleration until halfway, then deceleration
        default: return time;
      }
    };

    /**
     * Calculate how far to scroll
     */
    // let getEndLocation = (element) => {
    //   let location = 0,
    //     elementRect = element.getBoundingClientRect(),
    //     absoluteElementTop = elementRect.top + window.pageYOffset;

    //     location = absoluteElementTop;

    //   if (offset) {
    //     location = location - offset;
    //   }

    //   return Math.max(location, 0);
    // };

    // Initialize the whole thing

    let currentLocation = null,
      startLocation = getScrollLocation(),
      endLocation = endposition,// getEndLocation(element),
      timeLapsed = 0,
      distance = endLocation - startLocation,
      percentage,
      position,
      scrollHeight,
      internalHeight;

    /**
     * Stop the scrolling animation when the anchor is reached (or at the top/bottom of the page)
     */
    let stopAnimation = () => {
      currentLocation = getScrollLocation();
      if (containerPresent) {
        scrollHeight = container.scrollHeight;
        internalHeight = container.clientHeight + currentLocation;
      } else {
        scrollHeight = document.body.scrollHeight;
        internalHeight = window.innerHeight + currentLocation;
      }

      if (
        ( // condition 1
          position == endLocation
        ) ||
        ( // condition 2
          currentLocation == endLocation
        ) ||
        ( // condition 3
          internalHeight > scrollHeight
        )
      ) { // stop
        clearInterval(runAnimation);
        // 滚动结束回调
        duringScrolling(false);
        //  callbackAfter(element);
      }
    };

    /**
     * Scroll the page by an increment, and check if it's time to stop
     */
    let animateScroll = () => {
      timeLapsed += 16;
      percentage = (timeLapsed / duration);
      percentage = (percentage > 1) ? 1 : percentage;
      position = startLocation + (distance * getEasingPattern(!!options.easingPattern ? options.easingPattern : "easeInOutQuart", percentage));
      if (containerPresent) {
        container.scrollTop = position;
      } else {
        window.scrollTo(0, position);
      }
      stopAnimation();
    };

    // callbackBefore(element);

    let runAnimation = setInterval(animateScroll, 16);


  }
}
